import { api } from './api';
import type { LoginRequest, AuthResponse, User } from '../types';

export const authService = {
  login: async (credentials: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/api/v1/users/login', credentials);
    return response.data;
  },

  refreshToken: async (refreshToken: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/api/v1/users/refresh-token', { refreshToken });
    return response.data;
  },

  // Revoke the refresh token on the server so the logout is recorded (USER.LOGOUT audit).
  logout: async (refreshToken: string): Promise<void> => {
    await api.post('/api/v1/users/logout', { refreshToken });
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<{ data: User } | User>('/api/v1/users/me');
    // Handle both wrapped and unwrapped response formats
    const userData = (response.data as { data?: User }).data || response.data;
    return userData as User;
  },
};